import React from 'react'
import styles from './OrderStatus.module.scss'

const ORDER_STATUS_CONFIG = {
  raw: {
    label: 'Нове замовлення',
    className: styles.statusRaw,
  },
  booked: {
    label: 'Резерв',
    className: styles.statusBooked,
  },
}

function OrderStatus({ status }) {
  const config = ORDER_STATUS_CONFIG[status] || {
    label: status || '',
    className: styles.statusUnknown,
  }

  if (!config.label) return null

  return <span className={[styles.status, config.className].join(' ')}>{config.label}</span>
}

export { ORDER_STATUS_CONFIG }
export default OrderStatus
